import {GET_SOLICITATIONS_DECLINE_REASONS  } from "./actionTypes";

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = {}, action) => {
    switch(action.type) {
       case GET_SOLICITATIONS_DECLINE_REASONS:
          return action.payload;
       default:
          return state;  
    }
  }
  